var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleNetwork1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-network 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 11.2017C26.7614 11.2017 29 8.96308 29 6.20166C29 3.44024 26.7614 1.20166 24 1.20166C21.2386 1.20166 19 3.44024 19 6.20166C19 8.96308 21.2386 11.2017 24 11.2017Z",
    fill: "#9F795C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42 21.2017C44.7614 21.2017 47 18.9631 47 16.2017C47 13.4402 44.7614 11.2017 42 11.2017C39.2386 11.2017 37 13.4402 37 16.2017C37 18.9631 39.2386 21.2017 42 21.2017Z",
    fill: "#9F795C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6 21.2017C8.76142 21.2017 11 18.9631 11 16.2017C11 13.4402 8.76142 11.2017 6 11.2017C3.23858 11.2017 1 13.4402 1 16.2017C1 18.9631 3.23858 21.2017 6 21.2017Z",
    fill: "#9F795C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.968 38.2427L31.146 36.1837C29.329 38.0427 26.799 39.2017 24 39.2017C21.196 39.2017 18.663 38.0387 16.845 36.1737L12.03 38.2437C10.189 39.0327 9 40.8367 9 42.8397V46.2017C9 46.7537 9.448 47.2017 10 47.2017H38C38.552 47.2017 39 46.7537 39 46.2017V42.8397C39 40.8367 37.811 39.0327 35.968 38.2427Z",
    fill: "#9F795C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24 37.2017C19.582 37.2017 16 33.6197 16 29.2017V27.2017C16 22.7837 19.582 19.2017 24 19.2017C28.418 19.2017 32 22.7837 32 27.2017V29.2017C32 33.6197 28.418 37.2017 24 37.2017Z",
    fill: "#9F795C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleNetwork1);
export default __webpack_public_path__ + "static/media/people-network 1.37fe24cb83f3d94f0bb74d4f3d35f5e9.svg";
export { ForwardRef as ReactComponent };